import { createMutation } from '@tanstack/svelte-query';
import {
	createLEDScene,
	deleteLEDScene,
	updateLEDScene
} from '$lib/api/led_scene';
import { invalidateAfterLedSceneUpdate } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { LEDScene, LEDSceneWrite } from '$lib/types/led_scene';

export const createLedSceneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<LEDScene, Error, LEDSceneWrite>(() => ({
		mutationFn: (request) => createLEDScene(request),
		onSuccess: () => invalidateAfterLedSceneUpdate(resolveScope(scope))
	}));

export const updateLedSceneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<LEDScene, Error, { id: number; request: LEDSceneWrite }>(() => ({
		mutationFn: ({ id, request }) => updateLEDScene(id, request),
		onSuccess: () => invalidateAfterLedSceneUpdate(resolveScope(scope))
	}));

export const deleteLedSceneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteLEDScene(id),
		onSuccess: () => invalidateAfterLedSceneUpdate(resolveScope(scope))
	}));
